/**
 * 本地存储方法
 */


const DATA_KEY = 'KEWEB_DATA'
const ls = global.localStorage

const storage = {

  inited: false,
  data: {},

  init() {
    this.inited = !this.inited
    this.data = Object.assign({}, this.data, this.load())
    return this.data
  },

  save(data) {
    if (!this.inited) {
      this.init()
    }
    try {
      const newData = Object.assign({}, this.data, data)
      this.data = newData
      ls.setItem(DATA_KEY, JSON.stringify(newData))
      return this.data
    } catch (e) {
      return null
    }
  },

  clean() {
    return ls.removeItem(DATA_KEY)
  },

  load() {
    try {
      ls.setItem('supportStorage', true)
    } catch (e) {
      return null
    }
    ls.removeItem('supportStorage')
    if (!this.inited) return this.init()

    return JSON.parse(ls.getItem(DATA_KEY) ? ls.getItem(DATA_KEY) : 'null')
  },

}

export default storage



// WEBPACK FOOTER //
// ./src/core/storage.js